


// import { Box, Card, CardActions, CssBaseline, Grid, Typography, useTheme, Button, IconButton, Stack } from '@mui/material';
// import React, { useContext, useEffect, useState } from 'react';

// import AppModal from "../../../../../components/AppModal";
// import InvverterFullSize from "../../../../../components/inverter/InvverterFullSize";
// import { jsPDF } from "jspdf";
// import "jspdf-autotable"; // Ensure you import the autoTable plugin
// import * as XLSX from "xlsx";
// import logo from '../../../../../assets/img/logos/logo 2.png';
// import "./CurtailmentData.css"

// import RefreshIcon from '@mui/icons-material/Refresh';
// import { CurtailmentDataApi, DailyCurtailmentApi, PrAnalysisTab3Api } from '../../../../../api/Api';
// import { AppThemeContext } from '../../../../../context/AppThemeContext';
// import ExportExcel from '../../../../../components/exportExcel/ExportExcel1';
// import { PASS_KEY, WEB_KEY, BaseUrl } from '../../../../../api/AxiosApi'
// import { AuthenticationContext } from '../../../../../context/AuthenticationContext';
// import ExportPdf from '../../../../../components/exportPdf/ExportPdf';

// // Function to get default dates
// export function getDateTimeForDashboardTab1(date = new Date()) {
//     const formattedCurrentDate = date.toISOString().split("T")[0]; // Format: YYYY-MM-DD
//     const tenDaysAgo = new Date(date);
//     // tenDaysAgo.setDate(tenDaysAgo.getDate() - 0);
//     tenDaysAgo.setDate(tenDaysAgo.getDate() - 9);

//     const formattedTenDaysAgo = tenDaysAgo.toISOString().split("T")[0]; // Format: YYYY-MM-DD

//     return {
//         Today: formattedCurrentDate,
//         LastDay: formattedTenDaysAgo,
//     };
// }

// function CurtailmentData() {
//     const { LoggedInUserInfo } = useContext(AuthenticationContext)
//     const now = new Date();
//     const { PrimaryColor } = useContext(AppThemeContext);
//     const [StartDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay);
//     const [EndDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today);

//     const { palette, spacing, shape: { borderRadius } } = useTheme()
//     const [logData, setLogData] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);
//     const [currentPage, setCurrentPage] = useState(1);
//     const [itemsPerPage] = useState(15);


//     const [OpenMix, setOpenMix] = useState(false);
//     const handleOpenMix = () => setOpenMix(true);
//     const handleCloseMix = () => setOpenMix(false);

//     // Fetch data dynamically based on updated StartDate, EndDate, and ID
//     const credentials = {
//         LOGIN_ID: localStorage.getItem("LoginID") || "",
//         PASS_KEY: localStorage.getItem("PASS_KEY") || "xyz",
//         LCODE: localStorage.getItem("LCODE"),
//         WEB_KEY: "xyz",
//         DT1: StartDate,
//         DT2: EndDate,


//     };

//     const fetchLogData = async () => {
//         setLoading(true);
//         setError(null);
//         setLogData([]);

       

//         // console.log("data pram4 credentials:", logData);

//         try {
//             const res = await CurtailmentDataApi(credentials);
//             console.log(res)
//             if (res?.DAILY_CURT && Array.isArray(res.DAILY_CURT)) {
//                 setLogData(res.DAILY_CURT);
//             } else {
//                 setLogData([]);
//             }
//         } catch (err) {
//             // console.error("Error fetching data:", err);
//             setError("Failed to fetch data.");
//         } finally {
//             setLoading(false);
//         }
//     };

//      const ImageUrl = `${BaseUrl}CMN_02/GET_COM_LOGO?LOGIN_ID=${credentials.LOGIN_ID}&LOC_CODE=${credentials.LCODE}&PASS_KEY=${PASS_KEY}&WEB_KEY=${WEB_KEY}`

//     const indexOfLastItem = currentPage * itemsPerPage;
//     const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//     const currentData = logData.slice(indexOfFirstItem, indexOfLastItem);
//     const totalPages = Math.ceil(logData.length / itemsPerPage);

//     const handlePageChange = (pageNumber) => {
//         setCurrentPage(pageNumber);
//     };

//     // Get table headers from the first item in logData (dynamically)
//     const tableHeaders = logData.length > 0 ? Object.keys(logData[0]) : [];

   

//     const exportToExcel = async () => {
//         await ExportExcel(
//             ImageUrl,
//             logData,
//             StartDate,
//             EndDate,
//             "Daily Curtailment Log",
//             LoggedInUserInfo
//         );
//     };
      

//     const exportToPDF = async () => {
//         await ExportPdf(
//             ImageUrl,
//             currentData,
//             StartDate,
//             EndDate,
//             "Daily Curtailment Log",
//             LoggedInUserInfo,
//             logo,
//             tableHeaders
    
//         );
//     };

//     useEffect(() => {
//         fetchLogData();
//     }, [localStorage.getItem("LoginID")]);

//     // Refresh data only when clicking "Show"
//     function onRefreshData() {
//         if (StartDate.length !== 0 && EndDate.length !== 0) {
//             fetchLogData(); // Fetch data only after clicking the button
//         } else {
//             alert("Please provide valid dates");
//         }
//     }

//     const handleStartDateChange = (value) => {
//         setStartDate(value); // Update the StartDate directly
//     };

//     // Handle End Date change
//     const handleEndDateChange = (value) => {
//         setEndDate(value); // Update the EndDate directly
//     };

//     console.log("logdatacurtai",logData)

//     return (
//         <>
//             <Grid container style={{ padding: "0", margin: "0" }}>


//                 <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ overflow: 'hidden' }}>

//                     <Stack rowGap={spacing(0)} sx={{ marginTop: '.4rem', overflow: 'hidden' }}>
//                         {/* First Card */}
//                         <Stack
//                             component={Card}
//                             p={spacing(1)}
//                             sx={{ height: 'auto', overflow: 'hidden', marginBottom: spacing(2) }}
//                         >

//                             <div>

//                                 <div style={{
//                                     marginBottom: "5px",
//                                     display: "flex",
//                                     justifyContent: "space-between",
//                                     alignItems: "center",
//                                     gap: "16px",
//                                 }}>
//                                     {/* Left-side title */}
//                                     <div style={{ marginLeft: "7px", fontSize: "14px"  }}>
//                                         Daily Curtailment
//                                     </div>

//                                     {/* Right-side date pickers */}
//                                     <div style={{
//                                         display: "flex",
//                                         alignItems: "center",
//                                         gap: "10px"
//                                     }}>
//                                         <label>
//                                             From:&nbsp;
//                                             <input
//                                                 type="date"
//                                                 value={StartDate} // Use StartDate directly
//                                                 onChange={(e) => handleStartDateChange(e.target.value)}
//                                                 style={{
//                                                     padding: "2px 2px",
//                                                     borderRadius: "14px",
//                                                     border: "1px solid #ccc",
//                                                 }}
//                                             />
//                                         </label>
//                                         <label>
//                                             To:&nbsp;
//                                             <input
//                                                 type="date"
//                                                 value={EndDate} // Use EndDate directly
//                                                 onChange={(e) => handleEndDateChange(e.target.value)}
//                                                 style={{
//                                                     padding: "2px 2px",
//                                                     borderRadius: "14px",
//                                                     border: "1px solid #ccc",
//                                                 }}
//                                             />
//                                         </label>



//                                         <button onClick={onRefreshData} className='button-style' >Show</button>
//                                         <button onClick={exportToExcel} className='export-button' >Excel</button>
//                                         <button onClick={exportToPDF} className='export-button2' >PDF</button>



//                                     </div>
//                                 </div>

//                                 <div style={{ padding: "4px", marginTop: ".4rem" }}>


//                                     <div className="table-responsive">
//                                         <table className="table table-hover table-bordered">
//                                             <thead className="text-center" style={{ backgroundColor: "rgb(253, 248, 228)" }}>
//                                                 <tr>
//                                                     {tableHeaders.map((header, index) => (
//                                                         <th key={index} className='table-heading' style={{ color: PrimaryColor }}>{header}</th>
//                                                     ))}
//                                                 </tr>
//                                             </thead>
//                                             <tbody>
//                                                 {loading ? (
//                                                     <tr>
//                                                         <td colSpan={tableHeaders.length} className="text-center">Loading...</td>
//                                                     </tr>
//                                                 ) : currentData.length > 0 ? (
//                                                     currentData.map((item, rowIndex) => (
//                                                         <tr key={rowIndex}>
//                                                             {tableHeaders.map((key, index) => (
//                                                                 // <td key={index} className="text-center align-middle" style={tableBody}>
//                                                                 //     {item[key] || ""}
//                                                                 // </td>
//                                                                 <td key={index} className="text-center align-middle table-body">
//                                                                     {item[key] ?? ""}
//                                                                 </td>

//                                                             ))}
//                                                         </tr>
//                                                     ))
//                                                 ) : (
//                                                     <tr>
//                                                         <td colSpan={tableHeaders.length} className="text-center">No data available</td>
//                                                     </tr>
//                                                 )}
//                                             </tbody>
//                                         </table>
//                                     </div>

//                                     {/* Pagination */}
//                                     <div style={{ textAlign: "right", marginTop: "10px" }}>
//                                             <button
//                                                 onClick={() => handlePageChange(currentPage - 1)}
//                                                 disabled={currentPage === 1}
//                                                 className='pagination-button'
//                                             >
//                                                 Previous
//                                             </button>

//                                             {[...Array(totalPages)].map((_, index) => {
//                                                 const isActive = currentPage === index + 1;
//                                                 return (
//                                                     <button
//                                                     className='pagination-button'
//                                                         key={index}
//                                                         onClick={() => handlePageChange(index + 1)}
//                                                         style={{
//                                                             backgroundColor: isActive ? "#356E35" : "white",
//                                                             color: isActive ? "#fff" : "#356E35",
//                                                         }}
//                                                     >
//                                                         {index + 1}
//                                                     </button>
//                                                 );
//                                             })}

//                                             <button
//                                                 onClick={() => handlePageChange(currentPage + 1)}
//                                                 disabled={currentPage === totalPages}
//                                                 className='pagination-button'
//                                             >
//                                                 Next
//                                             </button>
//                                         </div>
//                                 </div>
//                             </div>
//                         </Stack>


//                     </Stack>


//                 </Grid>

//             </Grid>
//         </>
//     );
// }

// export default CurtailmentData;


import {
  Card,
  Grid,
  Stack,
  useTheme,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";

import { CurtailmentDataApi } from "../../../../../api/Api";
import { AppThemeContext } from "../../../../../context/AppThemeContext";
import { AuthenticationContext } from "../../../../../context/AuthenticationContext";

import ExportExcel from "../../../../../components/exportExcel/ExportExcel1";
import ExportPdf from "../../../../../components/exportPdf/ExportPdf";

import { PASS_KEY, WEB_KEY, BaseUrl } from "../../../../../api/AxiosApi";
import logo from "../../../../../assets/img/logos/logo 2.png";

import "./CurtailmentData.css";

/* ================= DATE HELPERS ================= */

// ✅ Today
export function getTodayDate(date = new Date()) {
  return date.toISOString().split("T")[0]; // YYYY-MM-DD
}

// ✅ Yesterday (DEFAULT)
export function getYesterdayDate(date = new Date()) {
  const yesterday = new Date(date);
  yesterday.setDate(yesterday.getDate() - 1);
  return yesterday.toISOString().split("T")[0];
}

// ✅ API expects DD-MMM-YYYY
function formatDateForApi(dateStr) {
  const date = new Date(dateStr);
  const day = String(date.getDate()).padStart(2, "0");
  const month = date
    .toLocaleString("en-US", { month: "short" })
    .toUpperCase();
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
}

/* ================= COMPONENT ================= */

function CurtailmentData() {
  const { LoggedInUserInfo } = useContext(AuthenticationContext);
  const { PrimaryColor } = useContext(AppThemeContext);
  const { spacing } = useTheme();

  // 🔥 DEFAULT DATE = YESTERDAY
  const [selectedDate, setSelectedDate] = useState(getYesterdayDate());

  const [logData, setLogData] = useState([]);
  const [loading, setLoading] = useState(false);

  /* ================= PAGINATION ================= */
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = logData.slice(indexOfFirstItem, indexOfLastItem);

  /* ================= API ================= */

  const credentials = {
    LOGIN_ID: localStorage.getItem("LoginID") || "",
    PASS_KEY: localStorage.getItem("PASS_KEY") || "xyz",
    LCODE: localStorage.getItem("LCODE") || "",
    WEB_KEY: "xyz",
    DT1: formatDateForApi(selectedDate),
    DT2: formatDateForApi(selectedDate),
  };

  const fetchLogData = async () => {
    setLoading(true);
    setLogData([]);

    try {
      console.log("API PARAMS:", credentials);
      const res = await CurtailmentDataApi(credentials);

      if (res?.DAILY_CURT && Array.isArray(res.DAILY_CURT)) {
        setLogData(res.DAILY_CURT);
        setCurrentPage(1);
      } else {
        setLogData([]);
      }
    } catch (error) {
      console.error("Fetch Error:", error);
    } finally {
      setLoading(false);
    }
  };

  // 🔥 AUTO LOAD (YESTERDAY DATA)
  useEffect(() => {
    fetchLogData();
  }, []);

  /* ================= EXPORT ================= */

  const ImageUrl = `${BaseUrl}CMN_02/GET_COM_LOGO?LOGIN_ID=${credentials.LOGIN_ID}&LOC_CODE=${credentials.LCODE}&PASS_KEY=${PASS_KEY}&WEB_KEY=${WEB_KEY}`;

  const tableHeaders =
    logData.length > 0 ? Object.keys(logData[0]) : [];

  const exportToExcel = async () => {
    await ExportExcel(
      ImageUrl,
      logData,
      selectedDate,
      selectedDate,
      "Day Wise Curtailment",
      LoggedInUserInfo
    );
  };

  const exportToPDF = async () => {
    await ExportPdf(
      ImageUrl,
      currentData,
      selectedDate,
      selectedDate,
      "Day Wise Curtailment",
      LoggedInUserInfo,
      logo,
      tableHeaders
    );
  };

  /* ================= RENDER ================= */

  return (
    <Grid container>
      <Grid item xs={12}>
        <Stack mt={1}>
          <Card sx={{ p: spacing(1) }}>

            {/* HEADER */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "8px",
              }}
            >
              <div style={{ fontSize: "14px" }}>
                <b>Day Wise Curtailment</b>
              </div>

              <div style={{ display: "flex", gap: "10px" }}>
                
                {/* ✅ DATE PICKER */}
                <label>
                  Date&nbsp;:&nbsp;
                  <input
                    type="date"
                    value={selectedDate}
                    max={getTodayDate()}   // ✅ TODAY ALLOWED
                    onChange={(e) =>
                      setSelectedDate(e.target.value)
                    }
                  />
                </label>

                <button
                  className="button-style"
                  onClick={fetchLogData}
                >
                  Show
                </button>

                <button
                  className="export-button"
                  onClick={exportToExcel}
                >
                  Excel
                </button>

                <button
                  className="export-button2"
                  onClick={exportToPDF}
                >
                  PDF
                </button>
              </div>
            </div>

            {/* TABLE */}
            <div className="table-responsive">
              <table className="table table-bordered table-hover">
                <thead
                  className="text-center"
                  style={{ backgroundColor: "#fdf8e4" }}
                >
                  <tr>
                    {tableHeaders.map((h, i) => (
                      <th key={i} style={{ color: PrimaryColor }}>
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan={tableHeaders.length} className="text-center">
                        Loading...
                      </td>
                    </tr>
                  ) : currentData.length > 0 ? (
                    currentData.map((row, i) => (
                      <tr key={i}>
                        {tableHeaders.map((key, idx) => (
                          <td key={idx} className="text-center">
                            {row[key] ?? ""}
                          </td>
                        ))}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={tableHeaders.length} className="text-center">
                        No curtailment data for selected date
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

          </Card>
        </Stack>
      </Grid>
    </Grid>
  );
}

export default CurtailmentData;

